import { GameListing } from './gameListing'

const routes = [
  {
    path: '/ladder',
    name: 'Up The Ladder',
    authenticated: true,
    render(props) {
      return <GameListing {...props} />
    }
  }
]

export { routes }
